import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=2d6b8bf4&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=2d6b8bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b8bf4",
  null
  
)

export default component.exports